// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 600px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: "https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png";
  background-size: cover;
  background-position: center;
  border-radius: 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.popuptitle {
  text-align: left;
  font-size: 20px !important;
  padding-left: 15px;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

.with-icon {
  text-align: left;
  height: 35px !important;
  display: flex;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
  box-shadow: none !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 150vh;
  background: #fff;
  border-radius: 0px !important;
  position: absolute;
  top: -100px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 80px 0px;
  display: none;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico {
  position: absolute;
  top: 6px;
  right: 10px;
  color: #212427;
  opacity: 1 !important;
  z-index: 10;
  position: fixed;
  top: unset;
  right: unset;
  max-width: 600px;
  width: 100%;
  margin: 0px auto;
  left: 0px;
  right: 0px;
  text-align: right;
}

.close-ico .fal {
  font-size: 25px;
  padding-right: 95px;
  padding-top: 5px;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  p span {
    width: 100%;
    display: block;
  }
}
.mat-badge-content {
  background: #5ea1d8;
}

.bundleIcon {
  position: absolute;
  bottom: 0px;
  right: 5px;
  z-index: 10;
  width: 25px;
  height: 25px;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 89vh;
  background: #efeeee !important;
}
.main-div .main-content {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 30px !important;
  width: 90%;
  max-width: 1000px;
  max-height: auto;
  width: 100%;
  position: relative;
  padding: 0px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
}
.main-div .mat-form-field-appearance-legacy .mat-form-field-underline {
  background: lightgray !important;
}
.main-div .font16 {
  font-size: 14px !important;
  font-family: "Raleway";
}
.main-div .table-wrapper .table-inner {
  border-radius: 5px;
  max-height: 300px;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border: 1px solid lightgray;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-div .table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.main-div .table-wrapper .table-inner video.video-display {
  width: 100%;
  height: 100%;
}
.main-div .table-wrapper p {
  color: rgba(0, 0, 0, 0.54) !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}
.main-div button.close {
  position: absolute;
  top: 20px;
  right: 22px;
  z-index: 1000;
}
.main-div .btn-primary {
  background-color: #5ea1d8;
  border: none;
}
.main-div .flowbycat {
  background-color: transparent;
}
.main-div .hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div .main-div {
    min-height: 92vh;
  }
  .main-div .main-content {
    width: 75%;
  }
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .main-content {
    width: calc(100% - 30px) !important;
    padding: 5px 5px 20px !important;
  }
}
@media (max-width: 460px) {
  .main-div .table-wrapper .table-inner {
    max-height: 150px;
    min-height: 150px;
  }
  .main-div .table-wrapper .table-inner img.img-display {
    max-height: 100px;
  }
  .main-div .table-wrapper .table-inner .video-display {
    max-height: 100px;
  }
}
/*new design starts here*/
.addbundle .user-pro .row {
  text-align: center;
  margin: 0px !important;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.addbundle .user-pro .item {
  margin-right: 0px !important;
  margin-left: 0px !important;
  border: 1px solid #ddd !important;
  margin: 10px !important;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: -2px 2px 7px hsla(0, 6%, 77%, 0.5);
  width: 22% !important;
}
.addbundle .user-pro .item p {
  text-align: left;
}
.addbundle .user-pro .item img {
  border: 1px solid #ddd;
  width: calc(100% - 10px) !important;
  height: 150px !important;
  border-radius: 0 !important;
  margin: 5px !important;
}
.addbundle .user-pro .item .with-icon {
  display: flex;
}
.addbundle .user-pro .item .with-icon > div {
  width: 40px !important;
}
.addbundle .user-pro .item .with-icon img {
  height: 30px !important;
  border-radius: 20px !important;
  object-fit: cover !important;
}
.addbundle .user-pro .mat-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}
.addbundle .user-pro .mat-checkbox .mat-checkbox-frame {
  border-color: rgb(94, 161, 216) !important;
}
.addbundle button.tickclass {
  font-size: 30px;
  color: black;
  position: sticky;
  top: 96px;
}
.addbundle button.tickclass .tickico {
  font-size: 22px;
  font-weight: bold;
}
.addbundle input {
  display: flex;
  justify-content: center;
  margin: 0px auto;
  width: 100% !important;
  margin-left: 0px !important;
}

@media (max-width: 1024px) {
  .addbundle .user-pro .row {
    width: 100% !important;
    display: flex;
  }
  .addbundle .user-pro .item {
    width: 30% !important;
    margin: 0px !important;
  }
  .addbundle button.tickclass .tickico {
    font-size: 30px !important;
  }
}
@media (max-width: 460px) {
  .addbundle .user-pro .row {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
  }
  .addbundle .user-pro .item {
    width: 46% !important;
    margin: 5px !important;
  }
}
button.owl-next {
  position: absolute;
  background: #fafafa !important;
  background: rgba(250, 250, 250, 0.7) !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: 0px;
}
button.owl-next span {
  font-size: 57px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -15px;
  font-weight: 400 !important;
  color: #5ea1d8;
}

.with-icon p {
  margin-top: 0px !important;
}

.stickybtn {
  position: fixed;
  bottom: 20px;
  max-width: 1000px;
  width: 100%;
  padding-right: 50px;
}
.stickybtn button {
  background: rgba(250, 250, 250, 0.7) !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: 0px;
  border: 0px;
}

.item {
  border: solid 0.5px lightgrey;
  margin: 5px 20px 0px 0px;
  width: 170px;
  position: relative;
  height: 100%;
}

/*price icon design*/
.square_btn {
  color: white;
  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  transition: all 0.3s ease;
}

.square_btn:hover {
  color: #fff;
  background-image: linear-gradient(45deg, #4679a6 0%, #4679a6 100%);
}

.square_btn:disabled {
  color: #ccc; /* Disabled text color */
  background-color: #e0e0e0; /* Disabled background color */
  background-image: none; /* Remove gradient for disabled state */
  cursor: not-allowed;
}

.square_btn:disabled:hover {
  color: #ccc;
  background-color: #e0e0e0;
}

:host-context(body.theme-dark) .box {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .box-wrap,
:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .title-box,
:host-context(body.theme-dark) .item {
  background: #1f2937 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .item {
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .partOfBundle {
  background: #111827 !important;
  color: #e5e7eb !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/checkout-navigator/checkout-navigator.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AACA;EACE,gBAAA;EACA,sBAAA;EAEA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,6HAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;AACF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAEF;;AAAA;EACE,gBAAA;EACE,0BAAA;EACA,kBAAA;AAGJ;;AADA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AAIF;;AAFA;EACE,gBAAA;EACA,uBAAA;EACA,aAAA;AAKF;AAJE;EACE,sBAAA;AAMJ;;AAFA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAKF;AAEM;EACE,8BAAA;EACA,2BAAA;EACA,2BAAA;AAAR;AAIE;EACE,yBAAA;AAFJ;;AAKA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAFF;;AAKA;EACE,yBAAA;EACA,aAAA;AAFF;;AAIA;EACE,6BAAA;AADF;;AAGA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AAGF;;AADA;EACE,gBAAA;EACA,kBAAA;AAIF;;AADA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAIF;;AAFA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAKF;;AAHA;EACE,kBAAA;EACE,QAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;AAMJ;;AAJA;EACE,eAAA;EAEE,mBAAA;EACA,gBAAA;AAMJ;;AAHA;EACE,aAAA;EACA,kBAAA;AAMF;;AAHA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAIF;;AADA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAIF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAAF;;AAIA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AADF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;AACE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AACJ;;AAEA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AACA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AAEF;AADE;EACE,aAAA;AAGJ;;AAAA;EACE;IACE,eAAA;IACA,2BAAA;EAGF;EAFE;IACE,WAAA;IACA,cAAA;EAIJ;AACF;AAIA;EACE,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAFF;AAGE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADJ;;AAKA;EACE,aAAA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAFJ;AAGI;EACA,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;AADJ;AAII;EACE,gCAAA;AAFN;AAKA;EAAS,0BAAA;EAA2B,sBAAA;AADpC;AAII;EACM,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFV;AAGU;EAEG,eAAA;EACA,iBAAA;EACA,mBAAA;AAFb;AAIW;EAAqB,WAAA;EAAa,YAAA;AAA7C;AAGK;EAAE,qCAAA;EAAkC,2BAAA;EAA4B,aAAA;EAAa,iBAAA;AAGlF;AADA;EACA,kBAAA;EACI,SAAA;EACA,WAAA;EACA,aAAA;AAGJ;AACA;EAAc,yBAAA;EAA0B,YAAA;AAGxC;AAFA;EAAW,6BAAA;AAKX;AAJA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAMF;AAFA;EACE;IACE,gBAAA;EAIF;EAFA;IACE,UAAA;EAIF;AACF;;AAAA;EACE;IACE,2BAAA;EAGF;EAFE;IACE,mCAAA;IACA,gCAAA;EAIJ;AACF;AAAA;EAEI;IACE,iBAAA;IACA,iBAAA;EACJ;EAAI;IACE,iBAAA;EAEN;EAAI;IACE,iBAAA;EAEN;AACF;AAEA,yBAAA;AAGI;EACE,kBAAA;EAEA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;AAHN;AAKI;EACE,4BAAA;EACA,2BAAA;EAEA,iCAAA;EACA,uBAAA;EACA,gBAAA;EACF,gBAAA;EACA,kBAAA;EACA,8CAAA;EACA,qBAAA;AAJJ;AAKI;EACE,gBAAA;AAHN;AAOI;EACE,sBAAA;EACA,mCAAA;EACF,wBAAA;EACA,2BAAA;EACA,sBAAA;AALJ;AAOI;EACE,aAAA;AALN;AAMM;EACE,sBAAA;AAJR;AAMM;EAEE,uBAAA;EACA,8BAAA;EACA,4BAAA;AALR;AAUI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AARN;AASM;EACE,0CAAA;AAPR;AAYE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;AAVJ;AAWI;EACE,eAAA;EACA,iBAAA;AATN;AAYA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;AAVF;;AAcA;EAGM;IACE,sBAAA;IACA,aAAA;EAbN;EAgBI;IACE,qBAAA;IACJ,sBAAA;EAdF;EAkBA;IACE,0BAAA;EAhBF;AACF;AAoBA;EAGM;IACE,sBAAA;IACA,aAAA;IACA,8BAAA;EApBN;EAsBI;IACE,qBAAA;IACJ,sBAAA;EApBF;AACF;AAwBA;EACE,kBAAA;EACA,8BAAA;EACA,+CAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AAvBF;AAyBE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AAvBJ;;AA2BE;EACE,0BAAA;AAxBJ;;AA2BA;EACE,eAAA;EAEE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAzBJ;AA0BI;EACE,+CAAA;EACF,iHAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;AAxBJ;;AAgCA;EACE,6BAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AA7BF;;AA+BA,oBAAA;AAKA;EACE,YAAA;EAEA,kEAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,yBAAA;AAhCF;;AAmCA;EACE,WAAA;EAEA,kEAAA;AAhCF;;AAmCA;EACE,WAAA,EAAA,wBAAA;EACA,yBAAA,EAAA,8BAAA;EACA,sBAAA,EAAA,uCAAA;EACA,mBAAA;AAhCF;;AAmCA;EACE,WAAA;EACA,yBAAA;AAhCF;;AAoCE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAjCJ;AAoCE;;;;EAIE,8BAAA;EACA,yBAAA;AAlCJ;AAqCE;EACE,iDAAA;AAnCJ;AAsCE;EACE,8BAAA;EACA,yBAAA;AApCJ","sourcesContent":[".container {\n  padding: 0px !important;\n  max-height:90vh;\n  overflow-y: auto;\n}\n.box {\n  max-width: 600px;\n  width: 100% !important;\n  // max-height:90vh;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background: \"https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png\";\n  background-size: cover;\n  background-position: center;\n  border-radius:0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n}\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.popuptitle{\n  text-align: left;\n    font-size: 20px !important;\n    padding-left: 15px;\n}\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height: 35px !important;\n  display: flex;\n  img {\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  // height: 300px;\n  // overflow-y: scroll;\n  // overflow-x: hidden;\n  // word-break: break-all;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 150vh;\n  background: #fff;\n  border-radius: 0px !important;\n  position: absolute;\n  top: -100px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 80px 0px;\n  display: none;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico {\n  position: absolute;\n    top: 6px;\n    right: 10px;\n    color: #212427;\n    opacity: 1 !important;\n    z-index: 10;\n    position: fixed;\n    top:unset;\n    right: unset;\n    max-width: 600px;\n    width: 100%;\n    margin: 0px auto;\n    left: 0px;\n    right: 0px;\n    text-align: right;\n}\n.close-ico .fal {\n  font-size: 25px;\n  \n    padding-right: 95px;\n    padding-top: 5px;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  // border: 1px solid rgb(236 72 153 );\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline: none !important;\n    border: 0.5px solid lightgrey;\n  }\n}\n.parent-comment-box {\n  background: #f3f1f1 !important;\n  padding: 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n  background: #f8f8f8 !important;\n  margin-left: 40px;\n  margin-top: 10px;\n  mat-card {\n    padding: 10px;\n  }\n}\n@media (max-width: 767px) {\n  p {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    span{\n      width:100%;\n      display:block;\n    }\n  }\n  .box {\n    // max-height:100vh;\n  }\n \n}\n\n.mat-badge-content {\n  background:#5ea1d8;\n}\n\n.bundleIcon {\n  position: absolute;\n  bottom: 0px;\n  right: 5px;\n  z-index: 10;\n  width: 25px;\n  height: 25px;\n  img{\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n} \n\n.main-div{\n  display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 89vh;\n    background: #efeeee !important;\n    .main-content{\n    border-radius: 10px 10px 10px 10px;\n    background: #fff;\n    padding: 20px 30px !important;\n    width: 90%;\n    max-width: 1000px;\n    max-height:auto;\n    width: 100%;\n    position: relative;\n    padding: 0px;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    text-align: center;\n    // border: 0.5px solid lightgrey;\n    }\n    .mat-form-field-appearance-legacy .mat-form-field-underline{\n      background:lightgray !important;\n    }\n\n.font16 {font-size: 14px!important; font-family:\"Raleway\";}\n.table-wrapper{\n\n    .table-inner {\n          border-radius: 5px;\n          max-height: 300px;\n          height: 100%;\n          position: relative;\n          overflow: hidden;\n          min-height: 300px;\n          border: 1px solid lightgray;\n          background: #fff;\n          display:flex;\n          align-items: center;\n          justify-content: center;\n          img.img-display {\n           \n             max-width: 100%;\n             max-height: 250px;\n             object-fit: contain;\n           }\n           video.video-display {width: 100%; height: 100%;}\n    }\n\n     p{color: rgba(0,0,0,.54)!important; text-align:left !important; padding:10px;line-height:20px;}\n}\nbutton.close{\nposition: absolute;\n    top: 20px;\n    right:22px;\n    z-index:1000;\n}\n\n\n.btn-primary {background-color:#5ea1d8; border: none;}\n.flowbycat{background-color: transparent;}\n.hide_file {\n  position: absolute;\n  z-index: 1000;\n  opacity: 0;\n  cursor: pointer;\n  right: 0;\n  top: 0;\n  height: 100%;\n  font-size: 24px;\n  width: 100%;\n}\n\n\n@media only screen and (max-width: 1024px) and (min-width: 768px){\n  .main-div{\n    min-height:92vh;\n  }\n  .main-content{\n    width:75%;\n  }\n}\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px){\n  .main-div{\n    background:#fff !important;\n    .main-content{\n      width:calc(100% - 30px) !important;\n      padding:5px 5px 20px !important;\n\n    }\n  }\n}\n@media(max-width:460px){\n  .main-div{\n    .table-wrapper .table-inner {\n      max-height: 150px;\n      min-height: 150px;\n      img.img-display{\n        max-height:100px;\n      }\n      .video-display{\n        max-height:100px;\n      }\n    }\n  }\n}\n/*new design starts here*/\n.addbundle{\n  .user-pro{\n    .row{\n      text-align: center;\n\n      margin:0px !important;\n      display: flex;\n      align-items: flex-start;\n      justify-content:flex-start;\n    }\n    .item{\n      margin-right:0px !important;\n      margin-left:0px !important;\n      // width: calc(100% - 10px)!important;\n      border: 1px solid #ddd !important;\n      margin:10px !important;\n      overflow: hidden;\n    background: #fff;\n    position:relative;\n    box-shadow:-2px 2px 7px hsl(0deg 6% 77% / 50%);\n    width:22% !important;\n    p{\n      text-align: left;\n\n    }\n\n    img{\n      border:1px solid #ddd;\n      width: calc(100% - 10px)!important;\n    height: 150px!important;\n    border-radius: 0!important;\n    margin:5px !important;\n    }\n    .with-icon{\n      display:flex;\n      &>div{\n        width:40px !important;\n      }\n      img{\n        // width:100% !important;\n        height:30px !important;\n        border-radius:20px !important;\n        object-fit: cover !important;\n      }\n    }\n\n    }\n    .mat-checkbox{\n      position: absolute;\n      top:5px;\n      right:5px;\n      .mat-checkbox-frame{\n        border-color:rgb(94, 161, 216) !important;\n      }\n    }\n\n  }\n  button.tickclass{\n    font-size: 30px;\n    color: black;\n    position: sticky;\n    top: 96px;\n    .tickico{\n      font-size:22px;\n      font-weight:bold;\n    }\n  }\ninput{\n  display: flex;\n  justify-content: center;\n  margin: 0px auto;\n  width: 100% !important;\n  margin-left: 0px !important;\n  \n}\n}\n@media(max-width:1024px){\n  .addbundle{\n    .user-pro{\n      .row{\n        width:100% !important;\n        display:flex;\n        // justify-content: space-between;\n      }\n      .item{\n        width: 30% !important;\n    margin: 0px !important;\n      }\n    }\n  }\n  .addbundle button.tickclass .tickico{\n    font-size:30px !important;\n  }\n\n}\n\n@media(max-width:460px){\n  .addbundle{\n    .user-pro{\n      .row{\n        width:100% !important;\n        display:flex;\n        justify-content: space-between;\n      }\n      .item{\n        width: 46% !important;\n    margin: 5px !important;\n      }\n    }\n  }\n}\nbutton.owl-next {\n  position: absolute;\n  background: #fafafa !important;\n  background: rgba(250,250,250,0.7) !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  right: 0px;\n  \n  span {\n    font-size: 57px;\n    line-height: 0px;\n    display: flex;\n    align-items: center;\n    margin-top: -15px;\n    font-weight: 400 !important;\n    color: #5ea1d8;\n  }\n}\n.with-icon{\n  p{\n    margin-top: 0px !important;\n  }\n}\n.stickybtn{\n  position: fixed;\n \n    bottom: 20px;\n    max-width: 1000px;\n    width: 100%;\n    padding-right: 50px;\n    button{\n      background: rgba(250, 250, 250, 0.7) !important;\n    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    right: 0px;\n    border: 0px;\n    }\n}\n// .docs-carousel-nav{\n//   position: fixed !important;\n//  bottom:unset !important;\n//  right:unset !important;\n// }\n.item {\n  border: solid 0.5px lightgrey;\n  margin: 5px 20px 0px 0px;\n  width: 170px;\n  position: relative;\n  height: 100%;\n}\n/*price icon design*/\n// .priceIcon-p { \n//   top: 112px !important;\n//   right: 220px !important; \n// }\n.square_btn {\n  color: white;\n  background-image: -webkit-linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-family: \"Raleway\", sans-serif;\n  transition: all 0.3s ease;\n}\n\n.square_btn:hover {\n  color: #fff;\n  background-image: -webkit-linear-gradient(45deg, #4679a6 0%, #4679a6 100%);\n  background-image: linear-gradient(45deg, #4679a6 0%, #4679a6 100%);\n}\n\n.square_btn:disabled {\n  color: #ccc; /* Disabled text color */\n  background-color: #e0e0e0; /* Disabled background color */\n  background-image: none; /* Remove gradient for disabled state */\n  cursor: not-allowed;\n}\n\n.square_btn:disabled:hover {\n  color: #ccc;\n  background-color: #e0e0e0;\n}\n\n:host-context(body.theme-dark) {\n  .box {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    color: #e5e7eb !important;\n  }\n\n  .box-wrap,\n  .des-box,\n  .title-box,\n  .item {\n    background: #1f2937 !important;\n    color: #e5e7eb !important;\n  }\n\n  .item {\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .partOfBundle {\n    background: #111827 !important;\n    color: #e5e7eb !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
